import React, { useState } from "react";
import classnames from "classnames";
import * as notify from "../../../shared/notify";
import eventEmitter from "../../../shared/events";

import MultiSelect from "../../form-inputs/custom/multi-select";

import { KEYCODE } from "../../../shared/constants";
import { Textarea } from "../../form-inputs/inputs";
import { useInput } from "../../../shared/hooks/form-fields";

const AddNote = ({ addNote, label, taskOptions }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const selectedTask = useInput("");
    const noteInput = useInput("");

    const saveOnEnter = (e) => {
        if (e.which === KEYCODE.RETURN || e.keyCode === KEYCODE.RETURN) {
            if (!e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                onAdd();
            }
        }
    };

    const onAdd = async () => {
        if (isSubmitting) {
            return;
        }

        let hasError = false;

        if (!noteInput.value) {
            notify.error("Please enter a note");
            hasError = true;
        }

        if (taskOptions && (!selectedTask.value || selectedTask.value.length <= 0)) {
            notify.error("Please select a task");
            hasError = true;
        }

        if (hasError) {
            return;
        }

        setIsSubmitting(true);
        const response = await addNote(noteInput.value, selectedTask.value);

        if (!response) {
            setIsSubmitting(false);

            return;
        }

        noteInput.reset();
        selectedTask.reset();
        setIsSubmitting(false);
        eventEmitter.emit("NOTE_ADDED");
    };

    return (
        <div className="add-note">
            {taskOptions && <MultiSelect label="Task(s)" options={taskOptions} {...selectedTask.bind} />}
            <Textarea {...noteInput.bind} label={label || "Your Note"} onKeyPress={saveOnEnter} />
            <button className={classnames("button -primary -full", { "-disabled": isSubmitting })} onClick={onAdd}>
                Add Note
            </button>
        </div>
    );
};

export default AddNote;
